import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import { MenuItemServices } from '@/services/modules/menu-item.service'
import store from '@/store'
import { APIMenuItem } from '@/models/api/menu-item.model'
import { Filter } from '@/interfaces/filter.interface'

@Module
export default class MenuItemStore extends VuexModule {
    menuItems: object[] = []
    menuItemsPaginate: object[] = []
    menuItemForm: object|null = null

    @Mutation
    updateMenuItems (newMenuItems: object[]) {
        this.menuItems = newMenuItems
    }

    @Mutation
    updateMenuItemsPaginate (newMenuItems: object[]) {
        this.menuItemsPaginate = newMenuItems
    }

    @Mutation
    updateMenuItem (newMenuItem: object) {
        this.menuItemForm = newMenuItem
    }

    @Action
    getMenuItem () {
        return new Promise((resolve) => {
            MenuItemServices.getMenuItems()
                .then(resp => {
                    store.commit('updateMenuItems', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getMenuItemPaginate (params: { page: number; filters?: Filter[]; limit: number }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            MenuItemServices.getMenuItemPaginate(newParams)
                .then(resp => {
                    store.commit('updateMenuItemsPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getMenuItemById (id: number) {
        return new Promise((resolve) => {
            MenuItemServices.getMenuItemById(id)
                .then(resp => {
                    store.commit('updateMenuItem', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createMenuItem (params: APIMenuItem) {
        params = new APIMenuItem(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIMenuItem)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            MenuItemServices.createMenuItem(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editMenuItem (params: APIMenuItem) {
        const id = params.menuItemId
        params = new APIMenuItem(params)

        delete params.childItems

        if (!id) {
            store.commit('reportError', { code: 1000, message: 'Missing Menu Item Id :(' })
            return Promise.resolve()
        }

        return new Promise((resolve) => {
            if (!(params instanceof APIMenuItem)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            MenuItemServices.editMenuItem(id, params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteMenuItem (id: number) {
        return new Promise((resolve) => {
            MenuItemServices.deleteMenuItem(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
